import { Component, Input  } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'breadcrumb-navigation',
  templateUrl: './breadcrumb-nav.component.html',
  styleUrls: ['./breadcrumb-nav.component.less']
})
export class BreadcrumbNavigation{
  @Input() titles: any[] = [];
  @Input() needHome: boolean = true;
  
  constructor(
    private translate: TranslateService,
    private router: Router,
  ) {

  }
  get breadcrumbList(): any[] {
    const home = {
      key: 'HOME_PAGE',
      url: `/home/index`
    }
    const list = this.needHome?[ home, ...this.titles ]:[...this.titles ];
    return list
  }
  handleNavigate(url: string): void {
    if(!url) return
    const country = localStorage.getItem("country");
    const urlNative = country?`${country}${url}`:url;
    this.router.navigate([urlNative]);
  }
}
